import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

export const routes = {
  customerLoginsPath: () => 'api/legacyAccounts',
  customerLoginsExportPath: () => 'api/legacyAccounts/export',
  customerLoginPathById: (id) => `api/legacyAccounts/${id}`,
  customerLoginRestorePath: (id) => `api/legacyAccounts/${id}/restore`,
  customerLoginMailCheckPath: (id) => `api/legacyAccounts/checkEmail`,
  accountTypesPath: () => 'api/legacyAccounts/accountTypes',
  customerLoginLegacyAccountsPath: (id) => `api/legacyAccounts/${id}/legacyAccounts`,
  unassignLegacyAccountsPath: (id, accountId) => `api/legacyAccounts/${id}/legacyAccounts/${accountId}`,
  customerLoginOrganizationsPath: (id) => `api/legacyAccounts/${id}/organizations`,
  deleteCustomerOrganizationsPath: (id, orgId) => `api/legacyAccounts/${id}/organizations/${orgId}`,
  customerLoginAuditsPathById: (id, params) => `/api/legacyAccounts/${id}/Audits${getQueryParams(params)}`,
  customerLoginAuditPropertiesPathById: (id) => `/api/legacyAccounts/${id}/Audits/Properties`,
  customerLoginAuditUsersPathById: (id) => `/api/legacyAccounts/${id}/Audits/Users`,
  welcomeEmailPath: (id) => `/api/LegacyAccounts/${id}/WelcomeEmail`,
};

export const getCustomerLogins = (params) =>
  makeRequest(authFetch.get(`${routes.customerLoginsPath()}${getQueryParams(params)}`));

export const getCustomerLoginsExport = (params) =>
makeRequest(authFetch.get(`${routes.customerLoginsExportPath()}${getQueryParams(params)}`));

export const getCustomerLoginById = (id) => makeRequest(authFetch.get(routes.customerLoginPathById(id)));

export const postCustomerLogin = (customerLogin) =>
  makeRequest(authFetch.post(routes.customerLoginsPath(), customerLogin));

export const updateCustomerLogin = (customerLogin) =>
  makeRequest(authFetch.put(routes.customerLoginsPath(), customerLogin));

export const checkCustomerLoginEmail = (data) =>
  makeRequest(authFetch.patch(routes.customerLoginMailCheckPath(), data));

export const deleteCustomerLogin = (id) => makeRequest(authFetch.delete(routes.customerLoginPathById(id)));

export const restoreCustomerLogin = (id) => makeRequest(authFetch.patch(routes.customerLoginRestorePath(id)));

export const getCustomerLoginAccountTypes = async () => makeRequest(authFetch.get(routes.accountTypesPath()));

export const getCustomerLegacyAccounts = async (id) =>
  makeRequest(authFetch.get(routes.customerLoginLegacyAccountsPath(id)));

export const unassignCustomerLegacyAccount = async (id, accountId) =>
  makeRequest(authFetch.delete(routes.unassignLegacyAccountsPath(id, accountId)));

export const assignCustomerLegacyAccount = async (id, account) =>
  makeRequest(authFetch.put(routes.customerLoginLegacyAccountsPath(id), account));

export const getCustomerOrganizations = async (id) =>
  makeRequest(authFetch.get(routes.customerLoginOrganizationsPath(id)));

export const unassignCustomerOrganization = async (id, accountId) =>
  makeRequest(authFetch.delete(routes.deleteCustomerOrganizationsPath(id, accountId)));

export const assignCustomerOrganization = async (id, orgId) =>
  makeRequest(authFetch.put(routes.customerLoginOrganizationsPath(id), orgId));

export const getCustomerLoginAudits = (id, params) =>
  makeRequest(authFetch.get(routes.customerLoginAuditsPathById(id, params)));

export const getCustomerLoginAuditProperties = (id) =>
  makeRequest(authFetch.get(routes.customerLoginAuditPropertiesPathById(id)));

export const getCustomerLoginAuditUsers = (id) =>
  makeRequest(authFetch.get(routes.customerLoginAuditUsersPathById(id)));

export const sendWelcomeEmail = (id) => makeRequest(authFetch.patch(routes.welcomeEmailPath(id), {}));
